import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { ApiLoginService } from '../../../../../src/app/api/api-login.service';
// import { DetailUser } from '../model/detailUser';
// import { CategoryNode } from '../model/categoryNode';
// import { Address } from '../model/address';

// const httpOptions = {
//   headers: new HttpHeaders({
//     'Content-Type':  'application/json'
//   })
// };

// const httpOptionstoken = {
//   headers: new HttpHeaders({
//     'Content-Type':  'application/json',
//     // 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
//     // 'Authorization' : "Bearer iUNN190UlfG5fKGzV5pHsIWrEELDfJ7a"
//     // 'Authorization' : "Bearer MSzNT2Jk-mILyGIVk9lcjxHUc2HKfi1L"
//   })
// };
@Injectable({
  providedIn: 'root'
})
 
export class ApiSgsService {

	// private urlApi = 'http://localhost:8000/';
  // public urlApi = 'http://coremanagement-dev.mncplaymedia.com/core-backend/public/';
  // public urlApi = 'http://localhost/sgsbackend/frontend/web/index.php/';
  // public urlApi = 'http://localhost/apiopencontent/frontend/web/index.php/'; 
  // public urlApivalsys = 'http://localhost/valsys/frontend/web/index.php/';
  // public urlApi = 'http://10.9.26.169/sgsapi/frontend/web/index.php/';
  //public urlApi = 'http://sgs-api-dev.mncplaymedia.com/frontend/web/index.php/';
  // public urlApi = 'http://localhost/sgsapi/frontend/web/index.php/'; //local
  // public urlApi = 'https://sgs-api-dev.mncplay.id/frontend/web/index.php/'; //dev_public 
  public urlApi = 'https://sgs-api.mncplay.id/frontend/web/index.php/'; //prod_public
  //public urlApiImage = 'https://sgs-api-dev.mncplay.id/frontend/web/index.php/';
   //public urlApiImage = 'http://localhost/sgsapi/frontend/web/index.php/';
   public urlApiImage = 'https://sgs-api.mncplay.id/frontend/web/index.php/';


  // public urlApilocation = "https://eu1.locationiq.com/v1/search.php?key=1d5dbcfc514ea6&format=json"

  constructor(
    private http: HttpClient,
    private apilogin: ApiLoginService,
  ) { }

  _httpOptions(){
    
    const currentUser:any = this.apilogin.currentUserValue;
    // console.log(currentUser);
    const isLoggedIn:any = currentUser && currentUser.data.access_token;
    // console.log(isLoggedIn);
  
    if ( isLoggedIn )
    {
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+currentUser.data.access_token,
              'referer-policy': 'no-referrer-when-downgrade'
            }),
          };
    }else{
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }
  }

  _httpAppOptions(){
    
    const currentUser:any = this.apilogin.currentUserValue;
    // console.log(currentUser);
    const isLoggedIn:any = currentUser && currentUser.data.access_token;
    // console.log(isLoggedIn);
  
    return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer 0FFtJ0MmiT071MWd367Y8vWrcyAL3hMV',
              'referer-policy': 'no-referrer-when-downgrade'
            }),
          };
    
  } 

  
  _httpOptionsparams(params:any){
    
    const currentUser:any = JSON.parse(localStorage.getItem('currentUser'));;
    // console.log(currentUser);
    const isLoggedIn:any = currentUser && currentUser.data.access_token;
    // console.log(isLoggedIn);
  
    if ( isLoggedIn )
    {
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+currentUser.data.access_token,
              'referer-policy': 'no-referrer-when-downgrade'
            }),
            params: params
          };
    }else{
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }
  } 

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  
  /* start test Api */
  // setCreateporspect(params: any){
  //     // console.log( JSON.stringify(getFormEditCategory));
  //     return this.http.post<any>(this.urlApivalsys + 'valsys/entryprospects/createprospect', (params), this._httpOptions());
  // }

  setUpload(params: any){
      // console.log( JSON.stringify(getFormEditCategory));
      
      return this.http.post<any>(this.urlApi + 'opencontent/orders/upload', (params), this._httpOptions());
  }
  /* end test Api */

  /* Account */
  checkAccount(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/accounts/checkaccountid/' + params.accountid, (params), this._httpOptions());
  }
  checkProspek(params: any){
      return this.http.post<any>(this.urlApi + 'subgetsub/prospeks/checkprospekid/' + params.prospekindex, (params), this._httpOptions());
  }
  /* End Account */

  /* SGS MEMBER */
  

  getProfile(params: any){
    return this.http.get<any>(this.urlApi + 'sgsmember/profiles', this._httpOptions());
  }

  getProfileById(id: any){
    return this.http.get<any>(this.urlApi + 'sgsmember/profiles/'+id, this._httpOptions());
  }

  getProspectByCode(code: any){
    return this.http.get<any>(this.urlApi + 'sgsmember/prospectcustomers/code/'+code, this._httpOptions());
  }

  getProspect(qs){
    return this.http.get<any>(this.urlApi + 'sgsmember/prospectcustomers'+qs, this._httpOptions());
  }

  getMember(qs){
    return this.http.get<any>(this.urlApi + 'sgsmember/members'+qs, this._httpOptions());
  }
// public and just app
  postNewmember(params: any){
    return this.http.post<any>(this.urlApi + 'sgsmember/members/new', (params), this._httpAppOptions());
  }

  postEditmember(params: any){
    return this.http.post<any>(this.urlApi + 'sgsmember/members/change', (params), this._httpOptionsparams({}));
  }

  postChangepassword(params: any){
    return this.http.post<any>(this.urlApi + 'sgsmember/members/changepassword', (params), this._httpOptionsparams({}));
  }

  searchCustomer(data: any){
    return this.http.post<any>(this.urlApi + 'sgsmember/profiles/customer', JSON.stringify(data), this._httpAppOptions() );
  }

}
